<ion-toolbar [style]="{ '--background': headerColor }" mode="ios">
  <div style="display: flex; flex-direction: row">
    <div class="image-container">
      <img [src]="logo" alt="" />
      <div>
        <p [style]="{ color: menuColor }">
          {{ title }}
        </p>
      </div>
    </div>
  </div>

  <ion-buttons slot="end">
    <!-- Sync in progress indicator -->
    <div *ngIf="isSyncing" class="sync-indicator" style="display: flex; align-items: center; margin-right: 8px;">
      <ion-spinner name="crescent" style="width: 16px; height: 16px; margin-right: 4px;"></ion-spinner>
      <span style="font-size: 12px; color: var(--ion-color-primary);">Sync in progress</span>
    </div>
    <ion-button size="small" fill="clear" (click)="infoClick()">
      <ion-icon
        class="scan-icon"
        slot="icon-only"
        src="./assets/icon/info.svg"
      ></ion-icon>
    </ion-button>
    <ion-button size="small" fill="clear" (click)="logoutClick()">
      <ion-icon
        class="scan-icon"
        slot="icon-only"
        src="./assets/icon/logout-dm.svg"
      ></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
